/**
 * Our Achievements Stats Bar
 */
import React from 'react';

const stats = [
  {
    value: '2500+',
    label: 'Members',
  },
  {
    value: '7000+',
    label: 'Loan Issued',
  },
  {
    value: '15+',
    label: 'Years experience',
  },
];

const OurAchievements = () => {
  return (
    <section className="py-6 md:py-4 bg-white">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-[#2f3951]">
            Our Achievements
          </h2>
          <div className="w-16 h-0.5 bg-[#ca9a37] mx-auto mt-2"></div>
        </div>

        {/* Stats Bar */}
        <div className="bg-[#f8f1e5] rounded-lg py-4 md:py-5 px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-2">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-[#ca9a37] text-xs md:text-sm font-medium tracking-wide mb-0.5">
                  {stat.label}
                </div>
                <div className="text-[#2f3951] text-2xl md:text-3xl font-bold">
                  {stat.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurAchievements;
